import { themeBackgrounds, themeColors } from "@dana/MobiusOverrides/styles/colors";
import { fontSizes, lineHeights } from "@dana/MobiusOverrides/styles/typography";
import { productImageStyles } from "@dana/Overrides/Widgets/ProductList/ProductListProductImage";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { css } from "styled-components";

productImageStyles.badgeAreaWrapper = mergeToNew(productImageStyles.badgeAreaWrapper, {
    css: css`
        position: initial;
    `,
});

productImageStyles.compareCheckbox = mergeToNew(productImageStyles.compareCheckbox, {
    css: css`
        align-self: flex-start;
        padding-top: 0;
        margin: 8px auto;
    `,
});

productImageStyles.productImage = mergeToNew(productImageStyles.productImage, {
    linkWrappingImage: {
        css: css`
            max-width: 150px;
            display: block;
            margin: 16px auto;
            min-height: 150px;
        `,
    },
});

productImageStyles.badgeTextWrapper = mergeToNew(productImageStyles.badgeTextWrapper, {
    css: css`
        right: 0% !important;
        top: 18px !important;
        z-index: 2;
        width: auto !important;
        overflow: visible;

        [class*="TextBadge"] {
            padding: 4px 16px;
            position: relative;
            text-wrap: auto;

            &::after {
                content: "";
                background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='7' height='10' viewBox='0 0 7 10' fill='none'%3E%3Cpath d='M-4.69387e-05 9.78115L-0.000116752 0.781067L7.00007 9.78119L-4.69387e-05 9.78115Z' fill='%23535353'/%3E%3C/svg%3E");
                background-repeat: no-repeat;
                position: absolute;
                top: -10px;
                right: -2px;
                width: 10px;
                height: 14px;
                z-index: 5;
            }
        }
    `,
});

productImageStyles.badgeText = mergeToNew(productImageStyles.badgeText, {
    css: css``,
});

productImageStyles.replacedBadgeWrapper = mergeToNew(productImageStyles.replacedBadgeWrapper, {
    css: css`
        position: absolute;
        background: ${themeColors.primary.richBlack};
        padding: 5px 20px;
        right: 0%;
        top: 18px;
        z-index: 2;
        width: auto;
        overflow: visible;

        &.with-overlay {
            top: 56px;
        }

        &.discontinued-badge {
            background: ${themeBackgrounds.badgeYellow};

            &.with-overlay {
                top: 59px;
            }

            &.has-interchange {
                top: 95px;
            }

            &.no-overlay {
                &.has-interchange {
                    top: 58px;
                }
            }
        }

        > div {
            position: relative;

            &::after {
                content: "";
                background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='7' height='10' viewBox='0 0 7 10' fill='none'%3E%3Cpath d='M-4.69387e-05 9.78115L-0.000116752 0.781067L7.00007 9.78119L-4.69387e-05 9.78115Z' fill='%23535353'/%3E%3C/svg%3E");
                background-repeat: no-repeat;
                position: absolute;
                top: -15px;
                right: -22px;
                width: 10px;
                height: 14px;
                z-index: 5;
            }
        }
    `,
});

productImageStyles.replacedBadgeTitle = mergeToNew(productImageStyles.replacedBadgeTitle, {
    size: fontSizes.small,
    lineHeight: lineHeights.default,
    color: themeColors.primary.white,

    css: css`
        &.discontinued-title {
            color: ${themeColors.danger};
        }
    `,
});
